import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Value } from "./Value";
export var ListOfIdentifiers = /*#__PURE__*/function (_Value) {
  _inherits(ListOfIdentifiers, _Value);
  var _super = _createSuper(ListOfIdentifiers);
  function ListOfIdentifiers() {
    var _this;
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, ListOfIdentifiers);
    _this = _super.call(this, value, params);
    _this.value = value;
    _this.params = params;
    return _this;
  }
  _createClass(ListOfIdentifiers, [{
    key: "serialize",
    value: function serialize() {
      return this.value;
    }
  }, {
    key: "attachNode",
    value: function attachNode(_ref) {
      var nodeIds = _ref.nodeIds,
        beforeId = _ref.beforeId;
      var index = this.value.indexOf(beforeId);
      var insertIndex = index === -1 ? this.value.length : index;
      this.value = [].concat(_toConsumableArray(this.value.slice(0, insertIndex)), _toConsumableArray(nodeIds), _toConsumableArray(this.value.slice(insertIndex)));
    }
  }, {
    key: "hasNode",
    value: function hasNode(_ref2) {
      var nodeId = _ref2.nodeId;
      return this.value.indexOf(nodeId) !== -1;
    }
  }, {
    key: "detachNode",
    value: function detachNode(_ref3) {
      var nodeId = _ref3.nodeId;
      var index = this.value.indexOf(nodeId);
      if (index === -1) throw new Error('Unable to detach, node not found');
      this.value = this.value.filter(function (id) {
        return id !== nodeId;
      });
      return {
        beforeId: this.value[index]
      };
    }
  }, {
    key: "accept",
    value: function accept() {}
  }]);
  return ListOfIdentifiers;
}(Value);